import React, { cloneElement, isValidElement } from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'outline';
  size?: 'default' | 'lg';
  asChild?: boolean;
  className?: string;
  children: React.ReactNode;
}
export const Button = ({
  variant = 'default',
  size = 'default',
  asChild = false,
  className = '',
  children,
  ...props
}: ButtonProps) => {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-300 disabled:pointer-events-none';
  const variantStyles = {
    default: 'bg-amber-300 text-slate-950 hover:bg-amber-400',
    outline: 'border hover:bg-slate-800 bg-transparent'
  };
  const sizeStyles = {
    default: 'h-9 px-4 py-2 text-sm',
    lg: 'h-11 px-8 text-base'
  };
  const classes = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`;
  if (asChild && isValidElement(children)) {
    return cloneElement(children, {
      className: `${classes} ${children.props.className || ''}`,
      ...props
    });
  }
  return <button className={classes} {...props} data-id="element-171" data-mp="3samz3yhzu9a4">
      {children}
    </button>;
};